<template>
	<div class="az-loading">
		<v-overlay :value="loadingEmExecucao">
			<v-card light color="white" width="300">
				<v-card-text class="theme--dark">
					{{ loadingMensagem }}
					<v-progress-linear indeterminate></v-progress-linear>
				</v-card-text
			></v-card>
		</v-overlay>
	</div>
</template>

<script>
export default {
	name: 'loading',
	computed: {
		loadingEmExecucao() {
			return this.$store.state.comum.requisicoesPendentes > 0 || this.$store.state.comum.loadingManual
		},
		loadingMensagem() {
			return this.$store.state.defaultLoadingMessage
		},
	},
}
</script>

<style lang="stylus" scoped>
.az-loading
	z-index 9999 !important
	position absolute
	font-family  'Open Sans', Arial, 'Sans-Serif'

>>> .v-progress-linear .v-progress-linear__indeterminate--active .long
	background-color var(--v-primary-base)

>>> .v-progress-linear__buffer
	background-color lightBlue

>>> .v-card__text
	font-weight 600
</style>
